import { useEffect, useRef, useState } from 'react';
import './index.scss';
import { LangText } from './LangText';
import { getCatalogTitleList } from './utils';
export default function BlogDetailsCatalog({ tempData = {}, locale = 'us' }: { tempData: any; locale: string }) {
    const theTemp = tempData?.theTemp || [];
    const theData = tempData?.theData || {};
    const itemsA = getCatalogTitleList(theTemp, theData);
    const TextA = LangText[locale] || LangText['us'];
    // 切换
    const [isOpen, setIsOpen] = useState(false);
    const [activeItemId, setActiveItemId] = useState<string>('');
    const catalogRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateStickyOffset = () => {
            let totalHeight = 12;

            const header = document.querySelector('.ecoflow-frame-header');
            if (header) {
                totalHeight += header.getBoundingClientRect().height;
            }
            if (catalogRef.current) {
                catalogRef.current.style.setProperty('--blog-delta-sticky-top-offset', `${totalHeight}px`);
            }
        };

        updateStickyOffset();

        window.addEventListener('resize', updateStickyOffset);
        return () => window.removeEventListener('resize', updateStickyOffset);
    }, []);

    // 监听浏览器 hash 锚点变化
    useEffect(() => {
        const updateActiveItem = () => {
            const hash = window.location.hash;
            if (hash) {
                setActiveItemId(hash);
            } else {
                setActiveItemId('');
            }
        };

        // 初始化时读取当前 hash
        updateActiveItem();

        // 监听 hash 变化
        window.addEventListener('hashchange', updateActiveItem);

        return () => {
            window.removeEventListener('hashchange', updateActiveItem);
        };
    }, []);
    const toggleHandle = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div ref={catalogRef} className={`blog-delta-catalog blog-delta-catalog-${isOpen ? 'y' : 'n'}`}>
            <div className="delta-catalog-box">
                <div className="delta-catalog-box-h" onClick={toggleHandle}>
                    {TextA.TableOfContents}
                </div>
                <ul className="delta-catalog-box-c">
                    {itemsA.map((item: any, index: number) => {
                        return (
                            <li key={index} className={`delta-catalog-box-item ${item.id === activeItemId ? 'active' : ''}`}>
                                <a href={item.id}>{item.title}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
